var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuiM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6377 14.9038C22.035 21.3325 15.5238 25.2448 9.09442 23.6417C2.66772 22.039 -1.24462 15.5275 0.358772 9.09935C1.96075 2.67001 8.47192 -1.24263 14.8993 0.360058C21.3283 1.96274 25.2404 8.47502 23.6375 14.904L23.6376 14.9038H23.6377Z",
    fill: "#4CA3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3904 10.2554C16.0022 11.0236 16.3681 11.9952 16.3681 13.052C16.3681 14.1089 15.9911 15.1101 15.3632 15.8826L15.3088 15.9494L15.2946 15.8647C15.2822 15.793 15.268 15.7201 15.2513 15.6472C14.9368 14.2652 13.9121 13.0805 12.2255 12.1207C11.0864 11.4742 10.4344 10.6967 10.2632 9.8123C10.1526 9.24064 10.2348 8.66647 10.3936 8.17449C10.5524 7.68317 10.7885 7.27095 10.9894 7.02311L11.6457 6.22091C11.7607 6.07999 11.9764 6.07999 12.0913 6.22091L15.391 10.2554H15.3904ZM16.4281 9.45383L12.0301 4.07695C11.9461 3.97435 11.7891 3.97435 11.7051 4.07695L7.30776 9.45383L7.29355 9.47178C6.48454 10.4761 6 11.7523 6 13.1417C6 16.3771 8.62726 19 11.8676 19C15.108 19 17.7352 16.3771 17.7352 13.1417C17.7352 11.7523 17.2507 10.4761 16.4417 9.47237L16.4274 9.45445L16.4281 9.45383ZM8.36027 10.2381L8.75334 9.75667L8.76508 9.84567C8.77435 9.91612 8.78609 9.98657 8.79969 10.0576C9.05432 11.3932 9.96345 12.5063 11.4832 13.3685C12.8046 14.1206 13.574 14.9853 13.7952 15.9333C13.8879 16.3289 13.904 16.7182 13.8639 17.0588L13.8614 17.0798L13.8422 17.089C13.2458 17.3801 12.5752 17.5439 11.867 17.5439C9.38188 17.5439 7.36709 15.5328 7.36709 13.0514C7.36709 11.9859 7.73853 11.0076 8.35903 10.2369L8.36027 10.2381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiM);
export default __webpack_public_path__ + "static/media/sui-m.fefe8b10914071a6be612d65a63ac80a.svg";
export { ForwardRef as ReactComponent };